// extracted by mini-css-extract-plugin
export default {"cls1":"MenuItem-cls1__b14e19c0651c2d53f50c","cls2":"MenuItem-cls2___d71f309721302687090 MenuItem-cls1__b14e19c0651c2d53f50c"};